import { FormBase } from 'core/components';

export default class MarkAsShippedLtlBulkForm extends FormBase {
	constructor(hooks) {
		super(hooks);
	}
	setup() {
		return {
			fields: [
				'fulfillmentOrders',
				'fulfillmentOrders[].fulfillmentOrderId',
				'fulfillmentOrders[].orderNumber',
				'fulfillmentOrders[].externalShipment',
				'fulfillmentOrders[].trackingNumber',
				'fulfillmentOrders[].carrierId',
				'fulfillmentOrders[].id',
			],
			labels: {
				'fulfillmentOrders[].fulfillmentOrderId': 'MARKASSHIPPEDBULKFORM.FO',
				'fulfillmentOrders[].orderNumber': 'MARKASSHIPPEDBULKFORM.MPO',
				'fulfillmentOrders[].trackingNumber': 'MARKASSHIPPEDBULKFORM.TRACKINGNUMBER',
				'fulfillmentOrders[].carrierId': 'MARKASSHIPPEDBULKFORM.CARRIER',
			},
			rules: {
				'fulfillmentOrders[].trackingNumber': 'required',
				'fulfillmentOrders[].carrierId': 'required',
			},
			types: {
				'fulfillmentOrders[].externalShipment': 'checkbox',
			},
			values: {
				'fulfillmentOrders[].externalShipment': false,
			},
		};
	}
}
